<template>
  <v-card flat class="settings-card">
    <!-- <v-card-title class="settings-header-text">Call Settings</v-card-title> -->
    <v-container>
      <v-card-title
        class="settings-header-text d-flex justify-space-between"
        v-if="settingsNavSelected == 'telecom-trck'"
      >
        <div class="mb-2">Call Tracking Numbers</div>
        <div class="mb-2">
          <v-btn
            depressed
            small
            class=""
            color="primary"
            @click="newCallTrackingNumber"
            >New Tracking Number</v-btn
          >
        </div>
      </v-card-title>
      <div v-if="settingsNavSelected == 'telecom-trck'">
        <list-type-fields
          :listTypeId="callTrackingTypeId"
          :ShowDialogName="isFalse"
          :EditItemFunction="editCallTrackingNumber"
          :Headers="callTrackingHeaders"
          class="telecom-grid-container px-4 pb-8"
        ></list-type-fields>
      </div>

      <v-card-title
        class="settings-header-text d-flex justify-space-between"
        v-if="settingsNavSelected == 'telecom-flow'"
      >
        <div class="mb-2">Call Flows</div>
        <div class="mb-2">
          <v-btn depressed small class="" color="primary" @click="newCallFlow"
            >New Call Flow</v-btn
          >
        </div>
      </v-card-title>
      <div v-if="settingsNavSelected == 'telecom-flow'">
        <list-type-fields
          :listTypeId="callFlowTypeId"
          :ShowDialogName="isFalse"
          :EditItemFunction="editCallFlow"
          class="telecom-grid-container px-4 pb-8"
        ></list-type-fields>
      </div>

      <v-card-title
        class="settings-header-text d-flex justify-space-between"
        v-if="settingsNavSelected == 'telecom-fwd'"
      >
        <div class="mb-2">Call Forwarding Numbers</div>
        <div class="mb-2">
          <v-btn
            depressed
            small
            class=""
            color="primary"
            @click="newDestinationNumber"
            >New Forwarding Number</v-btn
          >
        </div>
      </v-card-title>
      <div v-if="settingsNavSelected == 'telecom-fwd'">
        <list-type-fields
          :listTypeId="forwardingPhoneTypeId"
          :ShowDialogName="isFalse"
          :EditItemFunction="editDestinationNumber"
          :Headers="forwardingPhoneHeaders"
          class="telecom-grid-container px-4 pb-8"
        ></list-type-fields>
      </div>

      <v-card-title
        class="settings-header-text d-flex justify-space-between"
        v-if="settingsNavSelected == 'telecom-block'"
      >
        <div class="mb-2">Call/Text Blocking</div>
        <div class="mb-2">
          <v-btn
            depressed
            small
            class=""
            color="primary"
            @click="newBlockingNumber"
            >New Blocking Number</v-btn
          >
        </div>
      </v-card-title>
      <div v-if="settingsNavSelected == 'telecom-block'">
        <list-type-fields
          :listTypeId="callBlockTypeId"
          :ShowDialogName="isFalse"
          :EditItemFunction="editCallBlock"
          :Headers="callBlockHeaders"
          class="telecom-grid-container px-4 pb-8"
        ></list-type-fields>
      </div>
    </v-container>

    <div v-if="showDialogContainer">
      <v-dialog v-model="callTrackingDialog" max-width="800px" persistent>
        <call-tracking-modal
          class="dialog-background"
          :CallTrackingId="callTrackingId"
        ></call-tracking-modal>
      </v-dialog>
      <v-dialog v-model="callFlowDialog" max-width="855px" persistent>
        <call-flow-modal :callFlowId="flowId"></call-flow-modal>
      </v-dialog>
      <v-dialog v-model="destinationNumberDialog" max-width="550px" persistent>
        <call-forwarding-number-modal
          :PhoneNumberId="destinationNumberId"
        ></call-forwarding-number-modal>
      </v-dialog>
      <v-dialog v-model="callBlockingDialog" max-width="550px" persistent>
        <call-block-number-modal
          :PhoneNumberId="blockingNumberId"
        ></call-block-number-modal>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { mask } from "vue-the-mask";
import { TELECOM_INBOUND_CALL_METHODS } from "../../globalVars";
import ListTypeFields from "./fields/ListTypeFields";
import CallTrackingModal from "./telecom/CallTrackingModal";
import CallFlowModal from "./telecom/CallFlowModal";
import CallForwardingNumberModal from "./telecom/CallForwardingNumberModal";
import CallBlockNumberModal from "./telecom/CallBlockNumberModal";

export default {
  name: "TelecomSettings",
  components: {
    ListTypeFields,
    CallTrackingModal,
    CallFlowModal,
    CallForwardingNumberModal,
    CallBlockNumberModal
  },
  directives: {
    mask
  },
  data: function() {
    return {
      isFalse: false,
      isTrue: true,
      showDialogContainer: false,
      callTrackingDialog: false,
      callTrackingId: -1,
      callFlowDialog: false,
      flowId: -1,
      destinationNumberDialog: false,
      callBlockingDialog: false,
      destinationNumberId: -1,
      blockingNumberId: -1,
      callTrackingHeaders: [
        { text: "Order", value: "rank", sortable: false },
        {
          text: "Name",
          align: "start",
          value: "name",
          sortable: false
        },
        {
          text: "Phone Number",
          value: "meta.value.display"
        },
        {
          text: "Flow",
          value: "meta.value.flowId"
        },
        {
          text: "Source",
          value: "meta.value.sourceId"
        }
      ],
      forwardingPhoneHeaders: [
        { text: "Order", value: "rank", sortable: false },
        {
          text: "Name",
          align: "start",
          value: "name",
          sortable: false
        },
        {
          text: "Phone Number",
          value: "meta.display"
        }
      ],
      callBlockHeaders: [
        { text: "Order", value: "rank", sortable: false },
        {
          text: "Phone Number",
          align: "start",
          value: "name",
          sortable: false
        }
        // ,
        // {
        //   text: "Block Type",
        //   value: "meta.type"
        // }
      ],
      rules: {
        required: value => !!value || "Required"
      }
    };
  },
  computed: {
    settingsNavSelected() {
      return this.$parent.$parent.$parent.$parent.settingsNavSelected;
    },
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    inboundCallMethods() {
      return TELECOM_INBOUND_CALL_METHODS;
    },
    callTrackingTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("code", value => ["call_tracking_number"].includes(value))
        .first();
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    forwardingPhoneTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("code", value => ["forwarding_number"].includes(value))
        .first();
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    callFlowTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("code", value => ["call_flow"].includes(value))
        .first();
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    callBlockTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("code", value => ["phone_blocklist"].includes(value))
        .first();
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    }
  },
  async created() {},
  methods: {
    onOpenAnyDialogs(callback) {
      this.showDialogContainer = false;
      this.callTrackingDialog = false;
      this.callFlowDialog = false;
      this.destinationNumberDialog = false;
      this.$nextTick(() => {
        this.showDialogContainer = true;
        callback();
      });
    },
    newCallTrackingNumber() {
      let vueThis = this;
      vueThis.callTrackingId = -1;
      this.onOpenAnyDialogs(() => {
        vueThis.callTrackingDialog = true;
      });
    },
    editCallTrackingNumber(item) {
      let vueThis = this;
      vueThis.callTrackingId = item.id;
      this.onOpenAnyDialogs(() => {
        vueThis.callTrackingDialog = true;
      });
    },
    newCallFlow() {
      let vueThis = this;
      vueThis.flowId = -1;
      this.onOpenAnyDialogs(() => {
        vueThis.callFlowDialog = true;
      });
    },
    editCallFlow(item) {
      let vueThis = this;
      vueThis.flowId = item.id;
      this.onOpenAnyDialogs(() => {
        vueThis.callFlowDialog = true;
      });
    },
    newDestinationNumber() {
      let vueThis = this;
      vueThis.destinationNumberId = -1;
      this.onOpenAnyDialogs(() => {
        vueThis.destinationNumberDialog = true;
      });
    },
    editDestinationNumber(item) {
      let vueThis = this;
      vueThis.destinationNumberId = item.id;
      this.onOpenAnyDialogs(() => {
        vueThis.destinationNumberDialog = true;
      });
    },
    newBlockingNumber() {
      let vueThis = this;
      vueThis.blockingNumberId = -1;
      this.onOpenAnyDialogs(() => {
        vueThis.callBlockingDialog = true;
      });
    },
    editCallBlock(item) {
      let vueThis = this;
      vueThis.blockingNumberId = item.id;
      this.onOpenAnyDialogs(() => {
        vueThis.callBlockingDialog = true;
      });
    },
  },
  watch: {}
};
</script>

<style scoped lang="stylus">
div.spacer {
  width: 3rem;
}
div.settings-card > div, div.settings-card > div > div > div {
  padding-left: 0;
  padding-right: 0;
}
</style>
